import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import ActionButton from '@/components/action_button/Index.vue';
import FormHeader from '@/components/v2/FormHeader.vue';
import { THIRD_PARTY_PAYMENTS_APPLICATION_LINK } from '@/helpers/constants/app';
let ThirdPartyPaymentsApplicationsDialog = class ThirdPartyPaymentsApplicationsDialog extends Vue {
    get formHeader() {
        return 'Online Payment Providers';
    }
    redirectToGoogleForm() {
        window.open(THIRD_PARTY_PAYMENTS_APPLICATION_LINK, '_blank');
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], ThirdPartyPaymentsApplicationsDialog.prototype, "toggle", void 0);
ThirdPartyPaymentsApplicationsDialog = __decorate([
    Component({
        components: {
            FormHeader,
            ActionButton,
        },
    })
], ThirdPartyPaymentsApplicationsDialog);
export default ThirdPartyPaymentsApplicationsDialog;
